import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Box from '@mui/material/Box';
import { TableCellMonths } from '../components/tempData';

export default function LineCharts({ data, isLoading }) {
  const [getData, setGetData] = React.useState([]);

  React.useEffect(() => {
    if (data.length > 0) {
      const refinedData = TableCellMonths.map((months, index) => ({
        name: months,
        '2023-total-biz-inst-records': data[0].values[index],
      }));

      setGetData(refinedData);
    }
  }, [data]);

  // console.log(refinedData);

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flexStart">
      {!isLoading && (
        <ResponsiveContainer width="100%" height={500}>
          <LineChart
            data={getData}
            margin={{
              top: 5,
              right: 10,
              left: 0,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />

            <Line type="monotone" dataKey="2023-total-biz-inst-records" fill="#59dbd5" />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
}
